/**
 * `part` as a whole percentage of `whole` — a ratio of two integers, such as
 * credit utilisation, and not money.
 *
 * It lives here rather than in `money/totals.ts` on purpose: that file is exempt
 * from the `* 100` rule in `test/moneyFloatGuard.test.ts`, and a helper parked in
 * an exempt file is an exemption with no record. This one has an explicit ALLOW
 * entry there, with the condition that retires it.
 */
export function percentOf(part: number, whole: number): number {
  if (!(whole > 0)) throw new Error(`percentOf: whole must be positive, got ${whole}`)
  return Math.round((part / whole) * 100)
}
